// extracted by mini-css-extract-plugin
export default {"dialogList":"delete-subscription-modal_dialogList__S6L3U"};